export default (node) => {
  $('#hover-node-card .card-header').text(node.name)

  const delayReplyFor = node.data.delayReplyFor || ''
  const IsTypingOnDisplayChecked = node.data.IsTypingOnDisplayChecked || false

  if (! IsTypingOnDisplayChecked && ! delayReplyFor) {
    $('#hover-node-card .card-body').html('')
  } else {
    const html = `<p><strong>Delay in reply:</strong> ${delayReplyFor} second(s)</p>`

    $('#hover-node-card .card-body').html(html)
  }
}